import { useRef, useEffect, useState } from "react";
import { HiBadgeCheck } from "react-icons/hi";
import BOE from '../assets/BOE.webp';

export default function Boe() {
  const imageRef = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setInView(entry.isIntersecting),
      { threshold: 0.3 }
    );
    if (imageRef.current) observer.observe(imageRef.current);
    return () => {
      if (imageRef.current) observer.unobserve(imageRef.current);
    };
  }, []);

  const points = [
    "Get reminders to regularise your payments",
    "No more bank visits, submit all documents online.",
    "Knock off BOEs and Shipping Bills in EDPMS/IDPMS online"
  ];

  return (
    <section className="flex flex-col md:flex-row items-center justify-between px-4 md:px-8 lg:px-[15%] py-12 gap-8 text-gray-900">
      {/* Text Block */}
      <div className="w-full md:w-1/2 text-center md:text-left">
        <h2 className="font-bold text-2xl sm:text-3xl md:text-4xl lg:text-5xl leading-tight">
          BOE &amp; Shipping Bill Regularization​​
        </h2>
        <ul className="mt-6 space-y-4 text-left text-lg text-gray-600">
          {points.map((text, i) => (
            <li key={i} className="flex items-start">
              <HiBadgeCheck className="text-[#27a887] mr-3 mt-1 flex-shrink-0" />
              <span>{text}</span>
            </li>
          ))}
        </ul>
      </div>

      {/* Image Block */}
      <div className="w-full md:w-1/2 flex justify-center">
        <img
          ref={imageRef}
          src={BOE}
          alt="BOE and Shipping Bill illustration"
          className={`
            w-full
            max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg
            transition-transform duration-700 ease-in-out
            ${inView ? "scale-110" : "scale-95"}
          `}
        />
      </div>
    </section>
  );
}
